import { render } from "./SettingsInit.vue?vue&type=template&id=42b70760&ts=true"
import script from "./SettingsInit.vue?vue&type=script&lang=ts"
export * from "./SettingsInit.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__